<template>
  <div>
    <div :class="`bg-t-dark-- user-card-wrapper p-2`">
      <div class="user-card-container">
        <div class="user-img">
          <b-img v-bind="user_data" rounded="circle" alt="Circle image"></b-img>
        </div>
        <div class="user-detail">
          <div>
            <span class="user-name">Timpel</span>
          </div>
          <div>
            <span class="user-description">Timpel Medical</span>
          </div>
        </div>
        <!--
        <div class="user-notification-icon">
          <svg width="15" height="25" viewBox="0 0 25 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15.4166 3.37504V3.79778C19.6333 5.05275 22.7083 8.95897 22.7083 13.5834V23.7917H24.1666V26.7084H0.833252V23.7917H2.29159V13.5834C2.29159 8.95897 5.3665 5.05275 9.58325 3.79778V3.37504C9.58325 1.76421 10.8891 0.458374 12.4999 0.458374C14.1107 0.458374 15.4166 1.76421 15.4166 3.37504ZM5.20825 23.7917H19.7916V13.5834C19.7916 9.5563 16.527 6.29171 12.4999 6.29171C8.47284 6.29171 5.20825 9.5563 5.20825 13.5834V23.7917ZM15.4166 29.625V28.1667H9.58325V29.625C9.58325 31.2359 10.8891 32.5417 12.4999 32.5417C14.1107 32.5417 15.4166 31.2359 15.4166 29.625Z"
              fill="white" />
          </svg>
         
          <div id="notification-count">
            5
          </div>
          
      </div>
      -->
        <div class="language-switch">
          <span class="language">
            {{ $i18n.locale.toUpperCase() }}
            <b-dropdown id="switch-lang" size="sm" variant="transparent" toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <b-icon-chevron-down />
              </template>
              <b-dropdown-item v-for="l in $i18n.availableLocales" :key="l" @click="$i18n.locale = l">{{ l.toUpperCase()
                }}</b-dropdown-item>
            </b-dropdown>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
  },
  data() {
    return {
      environment: process.env.NODE_ENV,
      user_data: { blank: true, blankColor: '#777', width: 46, height: 46, class: 'm1' }
    }
  }
}
</script>

<style lang="scss">
.language-switch {
  position: absolute;
  color: #ffffff !important;

  path {
    fill: #ffffff !important;
  }

  bottom: -5px;
  right: -10px;
}

.user-notification-icon {
  padding-left: 20px;
  position: relative;

  #notification-count {
    position: absolute;
    top: 14px;
    right: -8px;
    background: #DC281E;
    border-radius: 50%;
    width: 14px;
    height: 14px;
    text-align: center;
    font-size: 10px;
  }
}

.user-card-wrapper {
  margin-top: 0.5rem !important;
  margin-right: 1.2rem !important;
  border-radius: 8px;

  @media only screen and (max-width: 600px) {
    margin-top: 0px !important;
    margin-right: 0px !important;
  }

  .user-card-container {
    position: relative;
    display: flex;
    min-width: 250px;

    .user-img {
      width: 28%;
      align-content: center;
    }

    .user-detail {
      width: 60%;
      align-content: right;
    }
  }
}

.user-name {
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
}

.user-description {
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  color: #FFFFFF;
}

.dropdown-menu {
  top: -7px !important;
}
</style>